import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-type-key",
  "use": "icon-leo-type-key-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-type-key\">\r\n<g transform=\"translate(-152.669 -113.571) scale(1.221818)\">\r\n<path d=\"M192 320h448v384H192V320zm64 64v256h320V384H256z\" />\r\n  <path d=\"M704 448h128v64H704v-64zm0 128h192v64H704v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-type-key.svg
// module id = +dZQ
// module chunks = 477